/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import moment from "moment";
import MainContainer from "../../layout/MainContainer";
import {
  Card,
  InputAdornment,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  TableBody,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import SearchIcon from "@mui/icons-material/Search";
import { Post } from "../../types/General";
import { Loader, showError } from "../../constants";
import { Pagination } from "../../components";
import { GetReport } from "../../services/report";
import { isValidInput } from "../../utils/validations";
import { useNavigate } from "react-router-dom";

const Reported = () => {
  const navigate = useNavigate();

  const [allReport, setAllReport] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [page, setPage] = useState(1);

  let totalPages = Math.ceil(totalCount / 10);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const getArticles = async () => {
    try {
      setLoading(true);
      const response = (await GetReport({
        limit: 10,
        skip: page - 1,
        search: searchTerm,
      })) as {
        status: number;
        count: number;
        data: Post[];
      };

      if (response?.status === 200) {
        setLoading(false);
        setAllReport(response?.data || []);
        setTotalCount(response?.count || 10);
        setLoading(false);
      } else {
        setLoading(false);
        setAllReport([]);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => setDebouncedSearchTerm(searchTerm), 1000);
    return () => clearTimeout(timerId);
  }, [searchTerm]);

  useEffect(() => {
    getArticles();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <div className="heading-bread">
            <h1 className="mn_hdng">Reported</h1>

            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/">
                Report management
              </Link>
              <Link
                underline="hover"
                color="inherit"
                href="/material-ui/getting-started/installation/"
              >
                Report List
              </Link>
            </Breadcrumbs>
          </div>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <Grid
              container
              spacing={2}
              sx={{ mb: 1 }}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs={12} md="auto">
                <TextField
                  placeholder="Search by Name or Email"
                  value={searchTerm}
                  size="small"
                  onChange={(e) => {
                    if (isValidInput(e.target.value)) {
                      setPage(1);
                      setSearchTerm(e.target.value);
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: { xs: "100%", md: 280 } }}
                />
              </Grid>
            </Grid>
          </Box>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>REPORTER</TableCell>
                  <TableCell>CONTENT</TableCell>
                  <TableCell>CONTENT UID</TableCell>
                  <TableCell>
                    AUTHOR <span></span>
                  </TableCell>
                  <TableCell>REASON</TableCell>
                  <TableCell>REPORTED</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {allReport &&
                  allReport.length > 0 &&
                  allReport.map((item: any, index: number) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/comments/${item?.commentId}`, {
                            state: { item },
                          })
                        }
                        onMouseDown={(e: React.MouseEvent) => {
                          // Middle click (button 1) or Ctrl+Click
                          if (e.button === 1 || (e.button === 0 && (e.ctrlKey || e.metaKey))) {
                            e.preventDefault();
                            window.open(`/comments/${item?.commentId}`, '_blank');
                          }
                        }}
                      >
                        <TableCell>{item?.user?.username}</TableCell>
                        <TableCell> COMMENT</TableCell>
                        <TableCell>{item?.uuid}</TableCell>
                        <TableCell>{item?.authorDetails?.username}</TableCell>
                        <TableCell>{item?.reportMassage}</TableCell>
                        <TableCell>
                          {moment(item?.updatedAt).format(
                            "MMM DD, YYYY (HH:mm)"
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
        <Pagination
          module={allReport || []}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      </div>
    </MainContainer>
  );
};

export default Reported;
